import { corporatePartners } from '../../models/profile-selector/corporate-partner/corporate-partner.const';
import { ICorporatePartner } from '../../models/profile-selector/corporate-partner/corporate-partner.interface';

export const getCorporatePartner = function (
  partnerId: string
): ICorporatePartner {
  for (const corpPartner of corporatePartners) {
    if (corpPartner.name === partnerId) {
      return corpPartner;
    }
  }

  return corporatePartners[0];
};
